import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { LocalBody } from '../models/localbody';
import { WardMaster } from '../user-view/models/wardMaster';
import { AssignMessages } from '../user-view/superAdmin/models/assignmessages';
import { DataencryptionService } from './dataencryption.service';

@Injectable()
export class LocalBodyService {
  headers: Headers;
  options: RequestOptions;
  storageEl: any;
  storageE2: any;
  ipAddress : any
  storageEl1: any;
  storageEl2: any;
  storageEL3: any;
  storageEL4: any;
  objFromDate: any;
  objToDate: any;
  decryptUID: any;
  decryptToken: any;
  UID: any;
  Token: any;
  localBodyArray: LocalBody[] = new Array<LocalBody>();
  wardMasterArr: WardMaster[] = new Array<WardMaster>();
  assignMsgArr: AssignMessages[] = new Array<AssignMessages>();

  BaseUrl= "https://webapi.truevoter.in/api";
  BaseUrl0 = environment.config.baseUrlDhananjoy;
  BaseUrlSujit = environment.config.baseUrlSujit;
  // baseUrl='https://webapi.truevoter.in/api';
  
  constructor(private http: Http, private cookieService: CookieService,
    private _encData: DataencryptionService) {

    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);

    this.headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Accept': 'application/json;charset=utf-8' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  uploadlocalbodydata(formData: FormData) {
    
    return this.http.post(this.BaseUrl + '/LocalBody/uploadlocalbodydata', formData)
      .map(res => res.json());
  }

  uploadPollingData(formData: FormData){
    return this.http.post(this.BaseUrl + '/uploadPollingExl', formData)
      .map(res => res.json());
  }


  downloadDistrict() {
 
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    var uid = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    var token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    // /LocalBody/downloaddistrict?stateId=27
    return this.http.get(this.BaseUrl + '/LocalBody/downloaddistrict?stateId=' + localStorage.getItem('stateId'))
      .map(res => res.json());
  }

  downloadAssemblyList(distId: number) {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    var uid = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    var token = this.decryptToken.toString(CryptoJS.enc.Utf8);

    return this.http.get(this.BaseUrl + '/LocalBody/downloadassembly?districtId=' + distId)
      .map(res => res.json());
  }

  downloadLocalBodyByDistId(distId: number) {
    return this.http.get(this.BaseUrl + '/ElectionProgram/getlocalbodyforEP?districtId=' + distId)
      .map(res => res.json());
  }

  addLocalBodyData(localBodyobj: LocalBody) {
    this.localBodyArray[0] = localBodyobj;
    // this.BaseUrl +
    // https://webapi.truevoter.in/api/LocalBody/addlocalbodydata1
    return this.http.post(this.BaseUrl + '/LocalBody/addlocalbodydata', this.localBodyArray)
      .map(res => res.json());
  }

  checkLBIDIsExist(lbid: number) {
    // https://webapi.truevoter.in/api/LocalBody/checklocalbodyid?lbId=54321
    return this.http.get(this.BaseUrl + '/LocalBody/checklocalbodyid?lbId=' + lbid)
      .map(res => res.json());
  }

  downloadLocalBody(lbType: number, distId: number, talukaId: number) {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    var uid = this.decryptUID.toString(CryptoJS.enc.Utf8);

    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    var token = this.decryptToken.toString(CryptoJS.enc.Utf8);

    // this.BaseUrl + 

    console.log(lbType, distId, talukaId);
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl + '/LocalBody/downloadlocalbody?uId=' + uid + '&lbType=' + lbType + '&distId=' + distId + '&talId=' + talukaId)
      .map(res => res.json());
  }

  activateStatus(id: number) {
    // this.BaseUrl + 
    return this.http.post(this.BaseUrl + '/LocalBody/updatelocalbody?localBodyId=' + id + '&lbStatus=' + 1, this.options)
      .map(res => res.json());
  }

  deactivateStatus(id: number) {
    // this.BaseUrl + 
    return this.http.post(this.BaseUrl + '/LocalBody/updatelocalbody?localBodyId=' + id + '&lbStatus=' + 0, this.options)
      .map(res => res.json());
  }

  downloadBasicDetails() {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);
   
    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this.http.get(this.BaseUrl + '/BasicDetails/downloadBasicDetails?uId=' + this.UID + '&epId=' + localStorage.getItem('electionProgId'))
      .map(res => res.json());
  }
  //--------------sushmita 02-08-2024---------------//
  downloadcandidateRecipt(CandidateMobNo:any,epId:any) {
   
    return this.http.get(this.BaseUrl + '/CandidateReciept/DownloadCandidateReciept?CandidateMobileNo=' + CandidateMobNo + '&EpId=' +epId)
      .map(res => res.json());
  }






   //kiran added 30_07_2024
  downloadBasicCandidateDetails() {
   // this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
   this.UID = localStorage.getItem('CandidateCreatedBy');
    
   console.log("local candiadte uid ",this.UID);
    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    return this.http.get(this.BaseUrl + '/BasicDetails/downloadBasicDetails?uId=' + this.UID + '&epId=' + localStorage.getItem('electionProgId'))
      .map(res => res.json());
  }


  downloadBasicDetailsByNominationId(nominationId) {
    return this.http.get(this.BaseUrl + '/BasicDetails/downloadDetailsByNomId?nominationId=' + nominationId)
      .map(res => res.json());
  }
  addWardMaster(wardMaster: WardMaster) {
    this.wardMasterArr[0] = wardMaster;
    // https://webapi.truevoter.in/api/WardMaster/wardmaster
    return this.http.post(this.BaseUrl + '/WardMaster/wardmaster', JSON.stringify(this.wardMasterArr), this.options)
      .map(res => res.json());
  }

  downloadWardMasterDetails() {
    return this.http.get(this.BaseUrl + '/WardMaster/downloadwardmaster?uId=' + this.UID)
      .map(res => res.json());
  }

  downloadDistData(stateId: number, epId: number) {
    return this.http.get(this.BaseUrl + '/LocalBody/downloaddistnamedistId?stateId=' + stateId + '&epId=' + epId)
      .map(res => res.json());
  }
  downloadLocalBodyByDistLBType(distId: number, localbodyType: number) {
    return this.http.get(this.BaseUrl + '/LocalBody/downloadlbIdBydistIdlbType?districtId=' + distId + '&localBodyType=' + localbodyType)
      .map(res => res.json());
  }

  downloadOfficerTreeReport(reffMobNo: string) {
    return this.http.get(this.BaseUrl + '/AddJunior/treeReportData1?referanceMobNo=' + reffMobNo)
      .map(res => res.json());
  }


  assignMessage(assignMsg: AssignMessages) {
    this.assignMsgArr[0] = assignMsg;
    return this.http.post(this.BaseUrl + '/AssignMessage/addorUpdateAssignMessage', this.assignMsgArr)
      .map(res => res.json());
  }

  downloadAssignMsg() {
    this.decryptUID = this._encData.decryptUID(this.cookieService.get('uId'));
    this.UID = this.decryptUID.toString(CryptoJS.enc.Utf8);
    this.decryptToken = this._encData.decryptToken(this.cookieService.get('token'));
    this.Token = this.decryptToken.toString(CryptoJS.enc.Utf8);
    // https://webapi.truevoter.in/api/AssignMessage/downloadAssignMessageByMobileNo?createdBy=a8ddc8da-86a1-429b-8c8c-d73b120a8b2c
    return this.http.get(this.BaseUrl + '/AssignMessage/downloadAssignMessageByMobileNo?createdBy' + this.UID +
      '&token=' + this.Token)
      .map(res => res.json());
  }

  downloadSeniorTreeReport(reffMobNo: string) {
    return this.http.get(this.BaseUrl + '/AddJunior/treeReporSeniortData?juniorMobNo=' + reffMobNo)
      .map(res => res.json());
  }

  downloadTalukaList(stateId: number, districtId: number) {
    return this.http.get(this.BaseUrl + '/LocalBody/downloadTalulaByStateDist?stateId=' + stateId + '&districtId=' + districtId)
      .map(res => res.json());
  }

  downloadVillageList(distId: number) {
    console.log(distId);
    return this.http.get(this.BaseUrl + '/LocalBody/downloadVillageList?districtId=' + distId)
      .map(res => res.json());
  }

  getLocalBodyCount(lbType: number, distId: number) {
    // https://webapi.truevoter.in/api/LocalBody/getLocalBodyCountByType?localBodyType=1&districtId=530
    return this.http.get(this.BaseUrl + '/LocalBody/getLocalBodyCountByType?localBodyType=' + lbType + '&districtId=' + distId)
      .map(res => res.json());
  }

  downloadCandidateEpId(epId:any,distId:any){
    return this.http.get(this.BaseUrl + '/SupportDbDetails/downldTotCandNomDetailsByEpIdNDistId?epId=' + epId + '&distId=' + distId)
    .map(res => res.json());
  }

  downloadCandidateDetailBasedOnEpId(epId:any,distId:any){
    return this.http.get(this.BaseUrl + '/Registration/downloadCandidateDetailBasedOnEpId?epId=' + epId + '&distId=' + distId)
    .map(res => res.json());
  }


  downloadCandidateEpId1(epId:any,distId:any,localbodyId:any, lbType:any){
    return this.http.get(this.BaseUrl +'/downloadpoolingstatement6?epId=' + epId + '&distId=' + distId+'&localBodyId='+localbodyId+'&localBodyType='+ lbType)
    .map(res => res.json());
  }

  downloadCensusEpId1(epId: any, distId: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement1?epId=' + epId + '&districtId=' + distId+'&localBodyType=0&localBodyId=0')
    .map(res => res.json());
  }
  downloadCensusdistId1(distId: any, lbType: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement1?epId=0&districtId='+distId+'&localBodyType=' + lbType + '&localBodyId=0')
    .map(res => res.json());
  }
  downloadCensusLbType(epId: any, distId: any, lbType: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement1?epId=' + epId + '&districtId=' + distId+'&localBodyType=' + lbType + '&localBodyId=0')
    .map(res => res.json());
  }
  downloadCensusLbId(epId: any, distId: any, lbType: any,lbId : any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl + '/downloadStatement1?epId=' + epId + '&districtId=' + distId+'&localBodyType=' + lbType + '&localBodyId=' + lbId)
    .map(res => res.json());
  }

  downloadContestingCandidate(epId: any, distId: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement5?epId=' + epId + '&districtId=' + distId + '&lbType=0&localBodyId=0')
    .map(res => res.json());
  }
  downloadContestingCandidateByLbType(epId: any, distId: any,lbType:any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement5?epId=' + epId + '&districtId=' + distId + '&lbType=' + lbType + '&localBodyId=0')
    .map(res => res.json());
  }

  downloadContestingCandidateByLbId(epId: any, distId: any,lbType:any, lbId: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadStatement5?epId=' + epId + '&districtId=' + distId + '&lbType=' + lbType + '&localBodyId=' + lbId)
    .map(res => res.json());
  }

  downloadOfficerEpId1(epId: any, distId: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/LocalBody/downloadOfficerData?electionProgId=' + epId + '&districtId=' + distId + '&localBodyType=0&localBodyId=0&roleId=0')
    .map(res => res.json());
  }

  downloadOfficerDetailsByMobNo(mobNo:any){
    return this.http.get(this.BaseUrl + '/supportOfficersDetails/downloadOfficersDetailsByMobNo?juniorMobile_no=' + mobNo)
    .map(res => res.json());
  }
  
  downloadStatement7(epId: any, distId: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/downloadpoolingstatement7?epId=' + epId + '&distId=' + distId + '&localBodyId=0&localBodyType=0')
    .map(res => res.json());
  }
  downloadStatement7byLbType(epId: any, distId: any, lbType: any, lbId: any) {
    console.log(this.BaseUrl + '/downloadpoolingstatement7?epId=' + epId + '&distId=' + distId + '&localBodyId='+lbId+'&localBodyType=' + lbType);
    return this.http.get(this.BaseUrl + '/downloadpoolingstatement7?epId=' + epId + '&distId=' + distId + '&localBodyId='+lbId+'&localBodyType=' + lbType)
    .map(res => res.json());
  }


  downloadOfficerEpId3(epId: any, distId: any,role: any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/LocalBody/downloadOfficerData?electionProgId=' + epId + '&districtId=' + distId + '&localBodyType=0&localBodyId=0&roleId=' + role)
    .map(res => res.json());
  }


  downloadCandidateLbId(epId:any,distId:any,lbType:any,lbId:any){
        // /downloadCandidateDetailBasedOnLbId?epId=
    return this.http.get(this.BaseUrl + '/Registration/downloadCandidateDetailBasedOnLbId?epId=' + epId + '&distId=' + distId + '&lbType='+lbType+'&lbId=' +lbId)
    .map(res => res.json());
  }

  downloadCandidateLbId1(epId:any,distId:any,lbType:any,lbId:any){
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl +'/LocalBody/downloadOfficerData?electionProgId=' + epId + '&distId=' + distId + '&localBodyType=' + lbType + '&localBodyId=0'+lbId+ '&roleId=0')
    .map(res => res.json());
  }
  downloadCandidateLbId2(epId:any,distId:any,lbType:any,lbId:any,role:any){
    // tslint:disable-next-line:max-line-length
    // https://webapi.truevoter.in/api/LocalBody/downloadOfficerData?electionProgId=30&districtId=530&localBodyType=1&localBodyId=54321&roleId=0
    return this.http.get(this.BaseUrl +'/LocalBody/downloadOfficerData?electionProgId=' + epId + '&distId=' + distId + '&localBodyType=' + lbType + '&localBodyId='+lbId +'&roleId=' + role)
    .map(res => res.json());
  }

  downloadCandidateMobNo(mobNo:any){
    // downloadCandidateDetailBasedOnMobNo?mobNo=
    // https://webapi.truevoter.in/api/Registration/downloadCandidateDetailBasedOnMobNo?mobNo=7276499436
    return this.http.get(this.BaseUrl + '/Registration/downloadCandidateDetailBasedOnMobNo?mobNo=' + mobNo)
    .map(res => res.json());
  }
  

  downloadCandidateWard(wardId:any,epId:any,distId:any){
    // https://webapi.truevoter.in/api/Registration/downloadCandidateDetailBasedOnWard?wardId=0&epId=337&distId=515
    return this.http.get(this.BaseUrl + '/Registration/downloadCandidateDetailBasedOnWard?wardId=' + wardId 
    + '&epId=' + epId + '&distId='+distId)
    .map(res => res.json());
  }

  downloadCandidateNom(nomId:any){
    // downloadCandidateDetailBasedOnNomination?nomId=
    // https://webapi.truevoter.in/api/Registration/downloadCandidateDetailBasedOnNomination?nomId=
    return this.http.get(this.BaseUrl + '/Registration/downloadCandidateDetailBasedOnNomination?nomId=' + nomId)
    .map(res => res.json());
  }

  downloadStatement9(epId: any, distId: any, lbtype: any, lbId: any ) {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl + '/downloadStatement9?epId=' + epId + '&districtId=' + distId + '&localBodyType=' + lbtype + '&localBodyId=' + lbId)
    .map(res => res.json());
  }

  downloadStatement10(epId: any, distId: any, lbtype: any, lbId: any ) {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.BaseUrl + '/downloadStatement10?epId=' + epId + '&districtId=' + distId + '&localBodyType=' + lbtype + '&localBodyId=' + lbId)
    .map(res => res.json());
  }

  downloadMaterialByepid(epId:any,distId:any){
    return this.http.get(this.BaseUrl + '/downloadstatement2?epId=' + epId + '&distId=' + distId + '&localBodyId=0&localBodyType=0')
    .map(res => res.json());
  }
  downloadMaterialByLbtype(epId:any,distId:any,lbType: any) {
    return this.http.get(this.BaseUrl + '/downloadstatement2?epId=' + epId + '&distId=' + distId + '&localBodyId=0&localBodyType=' + lbType)
    .map(res => res.json());
  }

  downloadMaterialByLbId(epId: any, distId: any, lbType: any, lbId: any) {
    return this.http.get(this.BaseUrl + '/downloadstatement2?epId=' + epId + '&distId=' + distId + '&localBodyId=' + lbId + '&localBodyType=' + lbType)
    .map(res => res.json());
  }

  downloadWinCandidateByLBType(epId: any, distId: any, lbType: any, lbId: any){
    return this.http.get(this.BaseUrl + '/downloadStatement11?epId='+epId+'&districtId='+distId+'&localBodyType='+lbType+'&localBodyId='+ lbId)
    .map(res => res.json());
  }

 // http://api.truevoter.in/True_Voter/downloadStatement10?epId=325&districtId=514&localBodyType=0&localBodyId=0

    statement11(epId:any, distId: any, lbType: any, lbId: any) {
      console.log(this.BaseUrl + '/downloadStatement11?epId='+epId+'&districtId='+distId+'&localBodyType='+lbType+'&localBodyId='+ lbId)
      return this.http.get(this.BaseUrl + '/downloadStatement11?epId='+epId+'&districtId='+distId+'&localBodyType='+lbType+'&localBodyId='+ lbId)
      .map(res => res.json());
    }

    uploadStatement1(file: File) {
      
      return this.http.post(this.BaseUrl + '/uploadStatement1Excel', file)
      .map(res => res.json());
    }
    downloadPollingDataByBoothNo(epId: any, distId: any, lbType: any, lbId: any,wardId: any,boothNo: any){
      return this.http.get(this.  BaseUrl + '/UploadPoolingData/downloadPoolingDataByepIdanddistId?epId=' + epId + '&distId=' + distId+'&localBodyType='+ lbType +'&localBodyId='+ lbId+ '&wardId=' + wardId+ '&boothNo=' + boothNo)
      .map(res => res.json());
    }
   

    downloadPollingDataByLBType(epId: any, distId: any, lbType: any, lbId: any,wardId: any,){
      return this.http.get(this.  BaseUrl + '/UploadPoolingData/downloadUploadPoolingDataByepIdanddistIdwardNo?epId=' + epId + '&distId=' + distId+'&localBodyType='+ lbType +'&localBodyId='+ lbId+ '&wardId=' + wardId )
      .map(res => res.json());
    }
    

    downloadPollingDataByEpId(epId: any, distId: any, ){
      return this.http.get(this.  BaseUrl + '/UploadPoolingData/downloadUploadPoolingDataByepIdanddistId?epId=' + epId + '&distId=' + distId)
      .map(res => res.json());
    }
// start from here
    downloadElectionDataByStatus(epId: any, distId: any, lbType: any, lbId: any, electionStatus: any){
      return this.http.get(this.  BaseUrl + '/downloadElectionDataByelectionStatusId?epId=' + epId + '&distId=' + 
      distId+'&localBodyType='+ lbType +'&localBodyId='+ lbId+ '&electionStatusId=' + electionStatus)
      .map(res => res.json());
    }

    downloadElectionDataByStatus1(epId: any, distId: any,  localBodyId: number,lbType: any, wardNO:any, boothNo:any, electionStatus: any){
      return this.http.get(this.  BaseUrl + '/UploadElectionData/downloadactivityreportdetails1?epId=' + epId + '&distId=' + 
      distId  +'&localBodyId='+ localBodyId +'&localBodyType='+ lbType +'&wardNo=' + wardNO + '&boothNo=' + boothNo + '&electionStatusId=' + electionStatus)
      .map(res => res.json());
    }
    downloadPRObyEpidnDistId(epId: any, distId: any,  localBodyId: number,lbType: any){
      return this.http.get(this.  BaseUrl + '/AddJunior/downloadPRObyEpidnDistId1?epId=' + epId + '&distId=' + 
      distId  +'&localBodyId='+ localBodyId +'&localBodyType='+ lbType )
      .map(res => res.json());
    }

    downloadPolingNPRODetails(epId: any, distId: any,  localBodyId: number,lbType: any, wardNO:any, boothNo:any){
      return this.http.get(this.  BaseUrl + '/UploadPoolingData/downloadPolingNPRODetails?epId=' + epId + '&distId=' + 
      distId  +'&localBodyId='+ localBodyId +'&localBodyType='+ lbType +'&wardNo=' + wardNO + '&boothNo=' + boothNo)
      .map(res => res.json());
    }

    downloadBillingAppCount(epId: any ){
      return this.http.get(this.BaseUrl + '/Registration/downloadBillingAppCountsByEpId?id=' + epId )
      .map(res => res.json());
    }

    downloadExpenseByEpidAndDistId(epId: any,distId: any){
      return this.http.get(this.BaseUrl + '/StandardRateUpload/downloadExpenseByEpidAndDistId?districtId=' + distId + '&electionProgramIdOld=' + epId)
      .map(res => res.json());
    }

    downloadofficersDetailsByAllNew(epId: any, distId: any, lbType: any, localBodyId: number, roleId:any){
      // /downloadofficersDetailsByAllNew?epId=
      return this.http.get(this.BaseUrl + '/Registration/downloadofficersDetailsByAllNew?epId='   + epId + '&distId=' + 
      distId   +'&localBodyType='+ lbType +'&localBodyId='+ localBodyId +'&juniorRole=' + roleId )
      .map(res => res.json());
    }
    GetAndAddStandardRateUpload(epId: any,distId: any , epIdNew : any , ip: any , uid: any){
      return this.http.get(this.BaseUrl + '/DailyExpense/GetAndAddStandardRateUpload?districtId=' + distId + '&electionProgramIdOld=' + epId + '&uId=' + this.UID + '&electionProgramId=' + epIdNew + '&ipAddress=' + this.ipAddress)  
      .map(res => res.json());
    }
    UpdateStandardRateUpload(standardRateModel:any){
      return this.http.post(this.BaseUrl + '/StandardRateUpload/UpdateStandardRateUpload' ,standardRateModel)//JSON.stringify(this.standardRateArr), this.UID)
      .map(res => res.json() )
    }

    downloadSymbAllotCountBylbIdWise(epId: any, lbMaxId : any ){
      return this.http.get(this.BaseUrl + '/Registration/downloadSymbAllotCountBylbIdWise?EPId=' + epId + '&lbMaxId=' + lbMaxId )
      .map(res => res.json());
    }

    dwnldGridViewBylbIdWise(epId: any, localBodyId : any ){
      return this.http.get(this.BaseUrl + '/Registration/dwnldGridViewBylbIdWise?EPId=' + epId + '&localBodyId=' + localBodyId )
      .map(res => res.json());
    }

    dwnldGridViewBylbIdWise1(epId: any, localBodyId1 : any ){
      return this.http.get(this.BaseUrl + '/Registration/dwnldGridViewBylbIdWise?EPId=' + epId + '&localBodyId=' + localBodyId1 )
      .map(res => res.json());
    }

    downloadDetailsByNomId(nominationRegNo){
      return this.http.get(this.BaseUrl + '/BasicDetails/downloadDetailsByNomId?nominationId=' + nominationRegNo )
      .map(res => res.json());
    }
    

}



// WEBPACK FOOTER //
// ./src/app/shared/local-body.service.ts